var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2849_29031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3347 8.44894L44.2092 4.15886C39.4257 1.80351 20.3754 -2.23421 7.70312 15.0944C14.249 7.60775 24.0679 5.33653 38.3347 8.44894Z",
    fill: "url(#paint0_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6272 52.0511L14.7527 56.3411C19.5362 58.6965 38.5866 62.7342 51.2588 45.4056C44.7129 52.8923 34.894 55.1635 20.6272 52.0511Z",
    fill: "url(#paint1_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7596 9.62196C12.6545 10.8864 7.61916 13.9962 5.01758 20.3051C9.63329 12.9026 16.2631 10.7155 22.8091 10.6314C30.1942 10.2949 37.4954 14.7532 41.0201 20.3051C41.0201 20.3051 54.3061 20.221 54.3637 20.3051C50.7551 15.0056 44.4609 10.7996 38.3346 9.03314C29.1871 6.59367 21.1306 7.43486 15.7596 9.62196Z",
    fill: "url(#paint2_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1184 50.8734C46.2234 49.609 51.2588 46.4992 53.8604 40.1902C49.2446 47.5927 42.6148 49.7798 36.0688 49.864C28.6837 50.2004 21.3825 45.7421 17.8578 40.1902C17.8578 40.1902 4.57181 40.2744 4.51423 40.1902C8.12286 45.4898 14.417 49.6957 20.5433 51.4622C29.6908 53.9017 37.7473 53.0605 43.1184 50.8734Z",
    fill: "url(#paint3_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2375 38.4237L53.105 38.4237C52.2658 41.3679 47.9018 48.7704 38.2508 47.1722C46.2234 47.4245 48.2375 40.9473 48.2375 38.4237Z",
    fill: "url(#paint4_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7244 22.0758L5.85693 22.0758C6.69615 19.1316 11.0601 11.7291 20.7111 13.3274C12.7385 13.075 10.7244 19.5522 10.7244 22.0758Z",
    fill: "url(#paint5_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 26.9109C2.5 26.7646 2.5524 26.6389 2.65719 26.5339C2.76198 26.4289 2.88736 26.3763 3.03332 26.3763H7.59745C8.11018 26.3763 8.57614 26.4476 8.99531 26.5902C9.41823 26.7327 9.77752 26.9841 10.0732 27.3442C10.3689 27.7006 10.5167 28.1433 10.5167 28.6722C10.5167 29.2499 10.2641 29.7451 9.75881 30.1578C10.4811 30.5404 10.8404 31.1631 10.8367 32.026C10.8367 32.795 10.5485 33.3915 9.97214 33.8154C9.39952 34.2356 8.6959 34.4456 7.8613 34.4456H3.03332C2.88736 34.4456 2.76198 34.395 2.65719 34.2937C2.5524 34.1887 2.5 34.063 2.5 33.9167V26.9109ZM4.61645 32.9263H7.82762C8.11954 32.9263 8.34035 32.84 8.49006 32.6675C8.64351 32.4949 8.72023 32.2586 8.72023 31.9584C8.72023 31.6583 8.64351 31.422 8.49006 31.2494C8.33661 31.0769 8.1158 30.9906 7.82762 30.9906H4.61645V32.9263ZM4.61645 29.5106H7.6199C7.85569 29.5106 8.04469 29.4412 8.18691 29.3024C8.32913 29.1599 8.40024 28.9629 8.40024 28.7116C8.40024 28.4565 8.32913 28.2577 8.18691 28.1151C8.04469 27.9726 7.85569 27.9013 7.6199 27.9013H4.61645V29.5106Z",
    fill: "url(#paint6_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.678 33.6128C11.9108 32.9376 11.5272 31.8703 11.5272 30.411C11.5272 28.9517 11.9108 27.8863 12.678 27.2148C13.4453 26.5433 14.5681 26.2075 16.0464 26.2075C17.5285 26.2075 18.6513 26.5433 19.4148 27.2148C20.182 27.8863 20.5656 28.9517 20.5656 30.411C20.5656 31.8703 20.182 32.9376 19.4148 33.6128C18.6513 34.2843 17.5285 34.6201 16.0464 34.6201C14.5681 34.6201 13.4453 34.2843 12.678 33.6128ZM14.2107 28.4021C13.8326 28.8523 13.6436 29.5238 13.6436 30.4166C13.6436 31.3057 13.8326 31.9753 14.2107 32.4255C14.5924 32.8719 15.2043 33.0951 16.0464 33.0951C16.8922 33.0951 17.5042 32.8719 17.8822 32.4255C18.2602 31.9753 18.4492 31.3057 18.4492 30.4166C18.4492 29.5238 18.2602 28.8523 17.8822 28.4021C17.5042 27.9519 16.8922 27.7268 16.0464 27.7268C15.2043 27.7268 14.5924 27.9519 14.2107 28.4021Z",
    fill: "url(#paint7_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2891 33.4946C21.5967 32.8306 21.2505 31.8046 21.2505 30.4166C21.2505 29.0248 21.5967 27.9969 22.2891 27.3329C22.9852 26.6652 24.0275 26.3313 25.416 26.3313H26.668C27.5175 26.3313 28.2679 26.5527 28.9191 26.9953C29.5741 27.438 29.9016 28.0438 29.9016 28.8129C29.9016 29.0342 29.8361 29.1936 29.7051 29.2912C29.5741 29.385 29.4468 29.4319 29.3233 29.4319H28.6553C28.311 29.4319 28.0434 29.2255 27.8525 28.8129C27.5755 28.2202 27.1152 27.9238 26.4715 27.9238H25.4722C24.6526 27.9238 24.0968 28.1001 23.8049 28.4527C23.5129 28.8054 23.367 29.4581 23.367 30.411C23.367 31.3638 23.5129 32.0185 23.8049 32.3749C24.0968 32.7275 24.6526 32.9038 25.4722 32.9038H26.5894C27.2331 32.9038 27.6916 32.6074 27.9648 32.0147C28.1556 31.5983 28.4251 31.3901 28.7732 31.3901H29.4412C29.5086 31.3901 29.5797 31.4051 29.6546 31.4351C29.7332 31.4614 29.8118 31.527 29.8903 31.6321C29.9727 31.7334 30.0139 31.8609 30.0139 32.0147C30.0139 32.7838 29.6882 33.3896 29.037 33.8323C28.3858 34.2712 27.6354 34.4907 26.7858 34.4907H25.416C24.0275 34.4907 22.9852 34.1587 22.2891 33.4946Z",
    fill: "url(#paint8_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1823 27.4399V26.9109C30.1823 26.7571 30.2328 26.6296 30.3338 26.5283C30.4349 26.427 30.5621 26.3763 30.7156 26.3763H37.8397C37.9931 26.3763 38.1204 26.427 38.2214 26.5283C38.3225 26.6296 38.373 26.7571 38.373 26.9109V27.4399C38.373 27.5937 38.3225 27.7212 38.2214 27.8225C38.1204 27.92 37.9931 27.9688 37.8397 27.9688H35.3359V33.9279C35.3359 34.0742 35.2835 34.198 35.1787 34.2993C35.0776 34.3969 34.9541 34.4456 34.8081 34.4456H33.7471C33.6012 34.4456 33.4758 34.3969 33.371 34.2993C33.2699 34.198 33.2194 34.0742 33.2194 33.9279V27.9688H30.7156C30.5621 27.9688 30.4349 27.92 30.3338 27.8225C30.2328 27.7212 30.1823 27.5937 30.1823 27.4399Z",
    fill: "url(#paint9_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6361 33.6128C38.8689 32.9376 38.4853 31.8703 38.4853 30.411C38.4853 28.9517 38.8689 27.8863 39.6361 27.2148C40.4034 26.5433 41.5261 26.2075 43.0045 26.2075C44.4866 26.2075 45.6093 26.5433 46.3728 27.2148C47.1401 27.8863 47.5237 28.9517 47.5237 30.411C47.5237 31.8703 47.1401 32.9376 46.3728 33.6128C45.6093 34.2843 44.4866 34.6201 43.0045 34.6201C41.5261 34.6201 40.4034 34.2843 39.6361 33.6128ZM41.1687 28.4021C40.7907 28.8523 40.6017 29.5238 40.6017 30.4166C40.6017 31.3057 40.7907 31.9753 41.1687 32.4255C41.5505 32.8719 42.1624 33.0951 43.0045 33.0951C43.8503 33.0951 44.4622 32.8719 44.8402 32.4255C45.2182 31.9753 45.4072 31.3057 45.4072 30.4166C45.4072 29.5238 45.2182 28.8523 44.8402 28.4021C44.4622 27.9519 43.8503 27.7268 43.0045 27.7268C42.1624 27.7268 41.5505 27.9519 41.1687 28.4021Z",
    fill: "url(#paint10_linear_2849_29031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6689 33.9054V26.9109C48.6689 26.7646 48.7213 26.6371 48.8261 26.5283C48.9309 26.4195 49.0563 26.3651 49.2023 26.3651H50.2577C50.4036 26.3651 50.5271 26.4195 50.6282 26.5283C50.733 26.6371 50.7854 26.7646 50.7854 26.9109V29.6063H51.9924C52.3217 29.6063 52.6099 29.5163 52.8569 29.3362C53.1077 29.1561 53.3453 28.8654 53.5699 28.464L54.4401 26.9109C54.6384 26.5508 54.9079 26.3688 55.2485 26.3651H56.5453C56.6912 26.3651 56.7773 26.4176 56.8035 26.5226C56.811 26.5489 56.8147 26.5752 56.8147 26.6014C56.8147 26.6877 56.7829 26.7909 56.7193 26.9109L55.5011 29.1224C55.3252 29.445 55.1268 29.7113 54.906 29.9214C54.6889 30.1315 54.4045 30.2797 54.0527 30.366C54.2997 30.4185 54.5523 30.5742 54.8106 30.833C55.0726 31.0919 55.3027 31.3732 55.5011 31.6771L56.9046 33.9167C56.9682 34.0255 57 34.1193 57 34.198C57 34.2318 56.9944 34.2637 56.9832 34.2937C56.9457 34.395 56.854 34.4456 56.7081 34.4456H55.4225C55.2765 34.4456 55.1193 34.395 54.9509 34.2937C54.7825 34.1887 54.6515 34.063 54.5579 33.9167L53.5699 32.3467C53.3341 31.9641 53.0965 31.6771 52.8569 31.4858C52.6174 31.2907 52.3292 31.1932 51.9924 31.1932H50.7854V33.9279C50.7854 34.0742 50.733 34.198 50.6282 34.2993C50.5271 34.3969 50.4036 34.4456 50.2577 34.4456H49.2023C49.0563 34.4456 48.9309 34.3931 48.8261 34.2881C48.7213 34.1793 48.6689 34.0517 48.6689 33.9054Z",
    fill: "url(#paint11_linear_2849_29031)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2849_29031",
    x1: 7.70313,
    y1: 15.1226,
    x2: 44.1388,
    y2: 4.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A5B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC7F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2849_29031",
    x1: 51.2588,
    y1: 45.3774,
    x2: 14.8231,
    y2: 56.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A5B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AC7F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2849_29031",
    x1: 54.3637,
    y1: 20.3382,
    x2: 5.82663,
    y2: 1.4045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2849_29031",
    x1: 4.51418,
    y1: 40.1572,
    x2: 53.0513,
    y2: 59.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2849_29031",
    x1: 39.2578,
    y1: 47.2443,
    x2: 51.1104,
    y2: 38.5225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2849_29031",
    x1: 19.7041,
    y1: 13.2552,
    x2: 7.85149,
    y2: 21.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2849_29031",
    x1: 29.3915,
    y1: 26.4543,
    x2: 29.3915,
    y2: 34.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7EC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2849_29031",
    x1: 29.3915,
    y1: 26.4543,
    x2: 29.3915,
    y2: 34.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7EC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2849_29031",
    x1: 29.3915,
    y1: 26.4543,
    x2: 29.3915,
    y2: 34.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7EC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2849_29031",
    x1: 29.3915,
    y1: 26.4543,
    x2: 29.3915,
    y2: 34.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7EC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2849_29031",
    x1: 29.3915,
    y1: 26.4543,
    x2: 29.3915,
    y2: 34.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7EC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2849_29031",
    x1: 29.3915,
    y1: 26.4543,
    x2: 29.3915,
    y2: 34.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7EC2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2849_29031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.573e253267bb44edcef45bec481a693e.svg";
export { ForwardRef as ReactComponent };